import React, { useEffect, useState , useRef} from 'react';
import { observer } from 'mobx-react';
import { useStore } from '../../../stores';
import { useServerFilterBriefs } from "../../../hooks/useBriefFilter";
import './style.scss';
import { OutlinedButton,PaginationControls, SearchBar } from '../../../components';
import PreviewBrief from '../BriefPreview';
import CreateBrief from "../Briefs/CreateBrief";

const AddIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/AddIcon.svg`;
const Credipple = `${process.env.REACT_APP_CDN_URL}/globalAssets/CredippleWhiteLogo.svg`;
const SearchIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/SearchIcon.svg`;
const UserIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/people.png`;
var mobile = require('is-mobile');

const Briefs = observer(() => {
    const { authStore, briefStore, uiStore } = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [IsViewClicked, setIsViewClicked] = useState(false);
    const [SelectedBrief, setSelectedBrief] = useState({});
    const [Briefs, setBriefs] = useState([]);
    const [Create, setCreate] = useState(false);
    const [Clients, setClients] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [Leads, setLeads] = useState([]);
    const [ProjectMenu, setProjectMenu] = useState(false);
    const [Professionals, setProfessionals] = useState([]);
    const [AllUsers, setAllUsers] = useState([]);
    const [Pagination, setPagination] = useState({ 
        currentPage :  1, 
        hasMore     : false, 
        nextCursor  : "", 
        prevCursor  : "",
        pageSize    : 8, 
        totalPages  : 0, 
        totalUsers  : 0
    })
    const isFirstRender = useRef(true);
    const { serverFilterBriefs } = useServerFilterBriefs({ briefStore, uiStore, setBriefs, setPagination, searchTerm });
    useEffect(() => {
        getBriefs("","");
    }, []);
    useEffect(()=>{
            if (isFirstRender.current) {
                isFirstRender.current = false; 
            
                return; 
            }else{
                if(searchTerm !== ""){
                    serverFilterBriefs(null, searchTerm, null, null, null, null);
                }else{
                    getBriefs("", "");
                };
            };
    }, [searchTerm]);
    const getBriefs = async (lastId, navId) => {
        uiStore.setLoading(true);
        try {
            const confirmedProjects = await briefStore.getBriefs(lastId, navId);
            setPagination({
                currentPage :  confirmedProjects?.currentPage ?? 1,
                hasMore     :  confirmedProjects?.hasMore ?? false,
                nextCursor  :  confirmedProjects?.nextCursor ?? "",
                prevCursor  :  confirmedProjects?.prevCursor ?? "",
                pageSize    :  confirmedProjects?.pageSize ?? 8,
                totalPages  :  confirmedProjects?.totalPages ?? 0,
                totalItems  :  confirmedProjects?.totalBriefs ?? 0
            });
            setBriefs(confirmedProjects?.briefs ?? []);
            forceUpdate();
        } catch (error) {
            uiStore.showNotification({ type: 'error', message: 'Error fetching briefs' });
        } finally {
            uiStore.setLoading(false);
        }
    };
    const openAddProjectMenu = () => {
        setProjectMenu(true);
        forceUpdate();
    };
    const closeAddProjectMenu = () => {
        setProjectMenu(false);
        forceUpdate();
    };
    const backClicked = (e, isEdited) => {
        if (isEdited) getBriefs();
        setIsViewClicked(false);
        setSelectedBrief({});
        forceUpdate();
    };
    const handleSelectedBrief = async (id) => {
        let projects = Briefs;
        let selectedProject = projects.find(project => project._id === id);
        setSelectedBrief(selectedProject);
        setIsViewClicked(true);
        forceUpdate();
    };
    const handleCreate = () => {
        setCreate(true);
    };
    const handleSearchChange = (value) => {
        setSearchTerm(value);
    };
    const handlePageChange = (e) => {
        const ID  = e;
        if (ID === 'next' && Pagination.hasMore) {
            getBriefs(Pagination.nextCursor, 'lastId');
        }else{
            if (Pagination.currentPage > 1) {
                getBriefs(Pagination.prevCursor,'prevId');
            }
        }
    };
    const filteredBriefs = Briefs.filter(brief => {
        const searchValue = String(searchTerm).toLowerCase();
        if (brief.briefTitle !== null) {
            return brief.briefTitle.toLowerCase().includes(searchValue);
        }
    });

    if (mobile()) {
        return <div></div>;
    } else {
        return (
            <div className='projectsPage'>
                <div className='projectsPageHeader' style={{ height: `${Object.keys(SelectedBrief).length > 0 ? '13%' : '26%'}` }}>
                    <div className='head_content'>
                        <div className='addbrief'>
                            <p className='brief_text'>Briefs</p>
                            {Object.keys(SelectedBrief).length === 0 &&
                                <div className='projectListSection'>
                                    <p style={{ color: 'white', margin: '0%' }}>Brief List</p>
                                    {authStore.user.permissions.includes("Brief_Create") &&
                                        <div className='addNewProjectMenu' onMouseEnter={openAddProjectMenu} onMouseLeave={closeAddProjectMenu}>
                                            {ProjectMenu &&
                                                <div className='userMenuOpen'>
                                                    <div className='AddUserConatiner'>
                                                        <img src={AddIcon} alt='Add User' onClick={handleCreate} />
                                                        <p style={{ cursor: 'pointer' }} onClick={handleCreate}>Add Brief</p>
                                                    </div>
                                                    <hr />
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </div>

                        {!IsViewClicked &&
                            <div className='numofItems' style={{ color:'white'}}>
                                <PaginationControls
                                    currentPage={Pagination.currentPage}
                                    totalPages={Pagination.totalPages}
                                    onPageChange={handlePageChange}
                                    hasMore={Pagination.hasMore}    
                                />
                                {/* <p className='spancular'>{filteredBriefs.length}</p> */}
                            </div>
                        }

                        <div className='search_filter'>
                            <img className='logo' src={Credipple} alt='Credipple Logo' />
                            {Object.keys(SelectedBrief).length === 0 &&
                                <div className='search-bar-section' style={{ height: '20%' }}>
                                <SearchBar
                                    onSearch={(e)=>handleSearchChange(e)}
                                    placeholder='Search'
                                    value = {searchTerm}
                                    debounceDelay={1000}
                                    disabled={false}
                                    className=''
                                    searchIconUrl={SearchIcon}
                                    style={{ width: '100%' }}
                                />
                                </div>
                            }
                        </div>
                    </div>
                </div>

                {!IsViewClicked &&
                    <div className='projectsPageBody'>
                        <div className='main'>
                            <span className='topbar_background' />
                            <div className='brief_cards_cover'>
                                {filteredBriefs.map((item, index) => (
                                    <div className='projectCard' key={index} onClick={() => handleSelectedBrief(item._id)}>
                                        <div className='viewprojectHeader'>
                                            <p>{item.briefTitle || ''}</p>
                                        </div>
                                        <div className='viewProjectDetails'>
                                            <div className='profileANdUserDetails'>
                                                <div className='userProfile'>
                                                    <img src={UserIcon} alt='User Icon' style={{ width: '100%', height: '100%' }} />
                                                </div>
                                                <div className='userProfile-Details'>
                                                    <p className='header' style={{ fontWeight: '700' }}>
                                                        {`${item.client?.firstName ?? ''} ${item.client?.lastName ?? item.client?.companyName ?? 'Not Assigned'}`.trim()}
                                                    </p>
                                                    <p className='value'>
                                                        {item.client?.email ? item.client.email.substring(0, 20) : item.client?.website ? item.client.website.substring(0, 20) : 'Not Assigned'}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className='fulfillmentLeadDetails'>
                                                <p className='header' style={{ fontWeight: '700', margin: '0px' }}>Fulfillment Lead</p>
                                                <p className='value' style={{ margin: '0px' }}>
                                                    {`${item.talentPartner?.firstName ?? 'Not Assigned'} ${item.talentPartner?.lastName ?? ''}`.trim()}
                                                </p>
                                            </div>
                                        </div>
                                        <div className='viewDetailsContainer'>
                                            <OutlinedButton className='detailsBtn'><p style={{ margin: '0' }}>View Details</p></OutlinedButton>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                }

                {Create &&
                    <CreateBrief
                        onClose={e => { setCreate(false); }}
                        SelectedBrief={SelectedBrief}
                        type={'Brief'}
                        briefs={Briefs}
                        clients={Clients}
                        leads={Leads}
                        isCreated={e => { if (e) getBriefs("",""); }}
                    />
                }

                {Object.keys(SelectedBrief).length > 0 &&
                    <div className='previewparent'>
                        <PreviewBrief
                            Briefs={Briefs}
                            setBriefs={setBriefs}
                            project={SelectedBrief}
                            AllUsers={AllUsers}
                            navigateMainToPage={(e, isEdited) => backClicked(e, isEdited)}
                            professionals={Professionals}
                            leads={Leads}
                        />
                    </div>
                }
            </div>
        );
    }
});

export default Briefs;
